import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading)
        return (
            <div className="min-h-[60vh] flex items-center justify-center text-[var(--lt-muted)]">
                Loading…
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
